<div>
  <form *ngIf="form && activityForm" class="mb-10 pl-5 row">
    <div class="row col-5" [formGroup]="form">
      <div class="col-10 p-0 template-form-field">
        <kt-general-autocomplete
          [appearance]="'outline'"
          [label]="'Task Template'"
          [loadItemsFunction]="templateAutocompleteCall"
          [optionFormatter]="filterTemplateFn"
          [valueFormatter]="filterTemplateFn"
          [control]="form.get('task_template')"
          [change]="onTemplateChange.bind(this)"
          [dataPath]="'data'"
          [placeholder]="'Select Task Template'"
          #templateAutocomplete
          [required]="true"
          [readOnly]="mode === 'view'"
        >
        </kt-general-autocomplete>
      </div>
      <div class="col-2">
        <div>
          <button
            mat-raised-button
            class="btn btn-primary w-100"
            (click)="addTemplate($event)"
            [disabled]="mode === 'view'"
            style="height: 46px; margin-top: 4px"
          >
            Add
          </button>
        </div>
      </div>
      <div class="col-12 border rounded mt-5 p-4 h-100">
        <div *ngIf="!relatedTemplates?.length" class="font-weight-bold text-center w-100 pt-25">
          There are no templates added!
        </div>
        <ng-container *ngIf="relatedTemplates?.length">
          <div class="row bg-light border rounded font-weight-bold m-0 mb-4 p-2 w-100">
            <div class="col-9">Task Template</div>
            <div class="col-2">Actions</div>
          </div>
          <div>
            <div
              *ngFor="let template of relatedTemplates; let idx = index"
              class="row border-bottom m-0 mb-2 p-2 w-100"
            >
              <div class="col-10">{{ template?.name }}</div>
              <div class="col-2" *ngIf="mode !== 'view'">
                <button
                  *ngIf="!(_templateId === template?.id)"
                  class="btn btn-icon btn-sm btn-light btn-hover-danger"
                  [matTooltip]="'TABLE.DELETE' | translate"
                  (click)="deleteTaskTemplate($event, template)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                    class="svg-icon svg-icon-md svg-icon-danger"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="col-1"></div>
    <div class="row col-5" [formGroup]="activityForm">
      <div class="col-10 p-0 template-form-field">
        <kt-general-autocomplete
          [appearance]="'outline'"
          [label]="'Activity Template'"
          [loadItemsFunction]="activityTemplateAutocompleteCall"
          [optionFormatter]="filterActivityTemplateFn"
          [valueFormatter]="filterActivityTemplateFn"
          [control]="activityForm.get('activity_template')"
          [change]="onActivityTemplateChange.bind(this)"
          [dataPath]="'data'"
          [placeholder]="'Select Activity Template'"
          #activityTemplateAutocomplete
          [required]="true"
          [readOnly]="mode === 'view'"
        >
        </kt-general-autocomplete>
      </div>
      <div class="col-2">
        <div>
          <button
            mat-raised-button
            class="btn btn-primary w-100"
            (click)="addActivityTemplate($event)"
            [disabled]="mode === 'view'"
            style="height: 46px; margin-top: 4px"
          >
            Add
          </button>
        </div>
      </div>
      <div class="col-12 border rounded mt-5 p-4 h-100">
        <div
          *ngIf="!relatedActivityTemplates?.length"
          class="font-weight-bold text-center w-100 pt-25"
        >
          There are no templates added!
        </div>
        <ng-container *ngIf="relatedActivityTemplates?.length">
          <div class="row bg-light border rounded font-weight-bold m-0 mb-4 p-2 w-100">
            <div class="col-10">Activity Template</div>
            <div class="col-2">Actions</div>
          </div>
          <div>
            <div
              *ngFor="let template of relatedActivityTemplates; let idx = index"
              class="row border-bottom m-0 mb-2 p-2 w-100"
            >
              <div class="col-9">{{ template?.name }}</div>
              <div class="col-2" *ngIf="mode !== 'view'">
                <button
                  *ngIf="!(_templateId === template?.id)"
                  class="btn btn-icon btn-sm btn-light btn-hover-danger"
                  [matTooltip]="'TABLE.DELETE' | translate"
                  (click)="deleteActivityTemplate($event, template)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                    class="svg-icon svg-icon-md svg-icon-danger"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </form>
</div>
